import styled from "styled-components";
import { COLORS, responsive } from "../../../../styles/constants.style";

export const ViewPurchaseOrderWrapper = styled.div`
  display: flex;
  flex-direction: column;
  background-color: ${COLORS.cirrus_white};

  .content {
    padding: 24px 16px;

    ${responsive.MOBILE`
      padding: 0 16px;
    `}
  }

  .notes-container {
    margin-top: 40px;
    ${responsive.MOBILE`
      margin-top: 16px;
      margin-bottom: 16px;
    `}
  }

  .separator {
    border-bottom: 1px dashed ${COLORS.primary_light_blue};
  }

  .po-reopen {
    margin-top: 24px;
    ${responsive.MOBILE`
      margin-top: 16px;
    `}
  }
`;
